// extracted by css-extract-rspack-plugin
export default {"button":"PartnerNumberAlert_button__RiO1j","container":"PartnerNumberAlert_container__jprnA","actionsWrapper":"PartnerNumberAlert_actionsWrapper__EEQ9z"};